import DemoPageWrapper from "../../utils/DemoPageWrapper";
import Demo from "./demo";
import DemoSource from "!!raw-loader!./demo.vue";
const config = {
  props: [
    {
      prop: "theme",
      description: "menu类型(available/highlight/shadow)",
      type: "String",
      default: "available"
    },
    {
      prop: "data",
      description: "菜单数据",
      type: "Array"
    },
    {
      prop: "boundariesSelector",
      description: "同dropdown boundariesSelector",
      type: "String"
    },
    {
      prop: "maxHeight",
      description: "菜单最大高度",
      type: "String",
      default: "auto"
    },
    {
      prop: "selectedKey",
      description: "选中的菜单项（支持多选）",
      type: "Array/Any"
    }
  ],
  events: [],
  methods: [],
  slots: []
};
export default DemoPageWrapper(Demo, DemoSource, config);
